import api from 'src/api'
import {
  IsmartPatrolListListProps,
  SmartPatrolOffenseResponse,
  IsmartPatrolExportPicturesProps,
  SmartPatrolOffense,
  IsmartPatrolExportProps,
} from 'src/api/gen'

export async function fetchSmartPatrolOffenses(props: IsmartPatrolListListProps): Promise<SmartPatrolOffenseResponse> {
  const result = await api.smartPatrol.smartPatrolListList(props)
  return result
}

export async function exportSmartPatrolOffenses(props?: IsmartPatrolExportProps): Promise<SmartPatrolOffense[]> {
  const result = await api.smartPatrol.smartPatrolExport(props)
  return result
}

export async function downloadSmartPatrolOffensesImages(props: IsmartPatrolExportPicturesProps): Promise<Response> {
  const result = await api.smartPatrol.smartPatrolExportPictures(props)
  return result
}
